import { Col, Form, Input, Row } from "antd";
import { useI18n } from "@/i18n";

export type WarehouseValues = {
  code?: string;
  name: string;
  address?: string;
  city?: string;
  postalCode?: string;
};

/** Shared by onboarding and Settings → Warehouses so both validate identically. */
export function WarehouseFields({ creating }: { creating: boolean }) {
  const { t } = useI18n();
  return (
    <Row gutter={16}>
      <Col xs={24} md={16}>
        <Form.Item
          name="name"
          label={t("common.name")}
          rules={[{ required: true, whitespace: true, min: 2, message: t("field.too_short") }, { max: 120, message: t("field.too_long") }]}
        >
          <Input autoFocus />
        </Form.Item>
      </Col>
      <Col xs={24} md={8}>
        <Form.Item
          name="code"
          label={`${t("settings.warehouses.code")} ${creating ? t("common.optional") : ""}`}
          extra={creating ? t("settings.warehouses.codeHelp") : undefined}
          normalize={(v: string) => v?.toUpperCase()}
          rules={[{ pattern: /^[A-Z0-9][A-Z0-9-]{0,15}$/, message: t("field.invalid") }]}
        >
          <Input disabled={!creating} maxLength={16} />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item name="address" label={`${t("settings.warehouses.address")} ${t("common.optional")}`} rules={[{ max: 500, message: t("field.too_long") }]}>
          <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} />
        </Form.Item>
      </Col>
      <Col xs={24} md={16}>
        <Form.Item name="city" label={`${t("settings.warehouses.city")} ${t("common.optional")}`} rules={[{ max: 120, message: t("field.too_long") }]}>
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={8}>
        <Form.Item
          name="postalCode"
          label={`${t("settings.warehouses.postalCode")} ${t("common.optional")}`}
          rules={[{ pattern: /^[0-9]{5}$/, message: t("field.invalid") }]}
        >
          <Input inputMode="numeric" maxLength={5} />
        </Form.Item>
      </Col>
    </Row>
  );
}
